module.exports = __webpack_public_path__ + "static/media/footer-bg.3a70756f.webp";